<!-- 产品样册 -->
<template>
    <div v-if="componentsData.type == 14">
        <div class="overflow-hidden"
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <div class="fw-bold"
                :style="`
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                    padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px 6px ${componentsData.content.marginData.left}px;
                `"
            >
                产品样册
            </div>
            <div
                :style="`
                    background: ${componentsData.content.text_bg_color}; font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};
                    padding: 6px ${componentsData.content.marginData.left}px ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;
                `"
            >
                <div class="display-flex">
                    <div class="w70">样册名称：</div>
                    <div class="content-div"
                        :style="
                            componentsData.content.height_id == 1
                                ? 'height: 200px;'
                                : componentsData.content.height_id == 2
                                ? 'height: 100px;'
                                : componentsData.content.height_id == 3
                                ? 'height: 150px;'
                                : componentsData.content.height_id == 4
                                ? 'height: 266.67px;'
                                : componentsData.content.height_id == 5
                                ? 'height: 400px;'
                                : 'height: 200px;'
                        "
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
}
.w70 {
    width: 70px !important;
    min-width: 70px !important;
    max-width: 70px !important;
}
.display-flex {
    display: flex;
    justify-content: space-between;
}
.content-div {
    border-radius: 10px;
    border: 1px solid #cccccc;
    background: #efefef;
    width: 200px;
}
</style>